import { app } from '../../bootstrap/core';
import { customerEntryState } from './customerEntry.state';
import { customerEntryComponent } from './customerEntry.component';

app.config(customerEntryState);
app.component(customerEntryComponent.name, customerEntryComponent);
